import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import {
  addAppointment,
  removeAppointment,
  resetAppointments,
  setAppointments,
} from './appointments-store.actions';
import { initialState, STORE_NAME } from './appointments-store.constant';
import {
  AppointmentsStore,
  AppointmentsStoreState,
} from './appointments-store.type';

export const useAppointmentsStore = create<
  AppointmentsStore & AppointmentsStoreState
>()(
  devtools(
    (set, get) => ({
      ...initialState,
      addAppointment: addAppointment(set, get),
      removeAppointment: removeAppointment(set, get),
      setAppointments: setAppointments(set),
      resetAppointments: resetAppointments(set),
    }),
    { name: STORE_NAME }
  )
);
